export default "__VITE_ASSET__b2058a42__"